export default __webpack_public_path__ + "static/media/glitch37.0cb13e46.png";